import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './poll-survey.component.scss';
import axios from 'axios';
import { AnalyticsService } from '../../services/analytics.service';
import * as $ from 'jquery';
var PollSurvey = /** @class */ (function (_super) {
    tslib_1.__extends(PollSurvey, _super);
    function PollSurvey(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openPollSurveyModal', _this, _this.openPollSurveyModal.bind(_this));
        return _this;
    }
    PollSurvey.prototype.init = function () {
        this.modals = Array.from(this.element.querySelectorAll('.js-poll-survey-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-poll-survey-modal-open'));
        this.closeButton = this.element.querySelector('.js-poll-survey-modal-close');
        this.openButton = this.element.querySelector('.js-poll-survey-modal-open');
        this.buttonContainer = this.element.querySelector('.poll-survey-toggle');
        this.activeModal = this.element.querySelector('.js-poll-survey-modal');
        this.toggleTabsButtons = Array.from(this.element.querySelectorAll('.js-toggle-tab'));
        this.tabs = Array.from(this.element.querySelectorAll('.poll-survey__tab-content'));
        // form
        this.form = this.element.querySelector('form');
        this.formSubmitButton = this.element.querySelector('.js-submit__generic-form');
        this.containerForm = this.element.querySelector('.poll-survey__messenger--content__form');
        this.containerLoader = this.element.querySelector('.poll-survey__messenger--content__loader');
        this.containerSuccess = this.element.querySelector('.poll-survey__messenger--content__success');
        this.containerTitle = this.element.querySelector('.poll-survey__messenger--header__title');
        this.containerSuccessMessage = this.element.querySelector('.js-success-message');
        // // attributes
        if (this.element.getAttribute('data-poll-id')) {
            this.attributePollId = this.element.getAttribute('data-poll-id');
            var checkStoragePollId = localStorage.getItem('sbgPollSubmitted');
            if (checkStoragePollId) {
                if (this.attributePollId === checkStoragePollId) {
                    this.containerForm.classList.add('d-none');
                    this.containerSuccess.classList.remove('d-none');
                }
            }
        }
        if (this.element.getAttribute('data-sitename')) {
            this.attributeSitename = this.element.getAttribute('data-sitename');
        }
        if (this.element.getAttribute('data-formname')) {
            this.attributeFormName = this.element.getAttribute('data-formname');
        }
        if (this.element.getAttribute('data-display-name')) {
            this.attributeDisplayName = this.element.getAttribute('data-display-name');
            this.containerTitle.innerHTML = this.attributeDisplayName;
        }
        if (this.element.getAttribute('data-frmcontainer')) {
            this.attributeAnalyticsName = this.element.getAttribute('data-frmcontainer');
        }
        if (this.element.getAttribute('data-pageurl')) {
            this.attributePageUrl = this.element.getAttribute('data-pageurl');
        }
        if (this.element.getAttribute('data-question')) {
            this.attributeQuestion = this.element.getAttribute('data-question');
        }
        if (this.element.getAttribute('data-success-message')) {
            this.attributeSuccessMessage = this.element.getAttribute('data-success-message');
            this.containerSuccessMessage.innerHTML = this.attributeSuccessMessage;
        }
    };
    PollSurvey.prototype.bindEvents = function () {
        var _this = this;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsidePollSurveyModal(event);
        }); });
        window.addEventListener('scroll', function (event) { return _this.onScroll(event); });
        this.closeButton.addEventListener('click', function (event) { return _this.closePollSurveyModal(); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openPollSurveyModals(event);
        }); });
        // form submit
        if (this.formSubmitButton) {
            this.formSubmitButton.addEventListener('click', function (event) {
                var formFields = _this.form.querySelectorAll('input, select, textarea');
                var validation = _this.validationService.validateEnterprise(formFields);
                if (validation.valid) {
                    _this.action();
                }
            });
        }
    };
    PollSurvey.prototype.onScroll = function (event) {
        var _this = this;
        setTimeout(function () {
            var footerHeight = document.querySelector('footer').offsetHeight;
            if ((window.innerHeight + document.documentElement.scrollTop) >= (document.body.offsetHeight - footerHeight)) {
                _this.hideComponent();
            }
            else {
                _this.showComponent();
            }
        }, 200);
    };
    PollSurvey.prototype.showComponent = function () {
        this.element.classList.remove('poll-survey--hidden');
    };
    PollSurvey.prototype.hideComponent = function () {
        this.element.classList.add('poll-survey--hidden');
    };
    PollSurvey.prototype.isClickOutsidePollSurveyModal = function (event) {
        if (event.target === this.activeModal) {
            this.closePollSurveyModal();
        }
    };
    PollSurvey.prototype.openPollSurveyModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-poll-survey-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        // this.activeModal = this.getPollSurveyModalById(modalId);
        this.openPollSurveyModal();
    };
    PollSurvey.prototype.closePollSurveyModal = function () {
        var _this = this;
        this.analyticsService.dtmFormAbandon();
        this.activeModal.classList.add('modal--close');
        this.activeModal.querySelector('.poll-survey__modal-dialog').classList.remove('poll-survey__modal-dialog--open');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
        this.showOpenButton();
    };
    PollSurvey.prototype.openPollSurveyModal = function () {
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
        this.activeModal.querySelector('.poll-survey__modal-dialog').classList.add('poll-survey__modal-dialog--open');
        this.showCloseButton();
    };
    PollSurvey.prototype.getPollSurveyModalById = function (id) {
        console.log('Poll Survey ID', id);
        if (this.element.querySelector("#" + id)) {
            console.log('Valid Selector');
            return this.element.querySelector("#" + id);
        }
        else {
            console.log('Invalid Selector');
        }
    };
    PollSurvey.prototype.showOpenButton = function () {
        var _this = this;
        this.closeButton.classList.remove('poll-survey-toggle__toggle-icon--visible');
        setTimeout(function () {
            _this.buttonContainer.classList.add('poll-survey-toggle--closed');
        }, 150);
        setTimeout(function () {
            _this.openButton.classList.add('poll-survey-toggle__toggle-text--visible');
        }, 300);
    };
    PollSurvey.prototype.showCloseButton = function () {
        var _this = this;
        this.openButton.classList.remove('poll-survey-toggle__toggle-text--visible');
        setTimeout(function () {
            _this.buttonContainer.classList.remove('poll-survey-toggle--closed');
        }, 150);
        setTimeout(function () {
            _this.closeButton.classList.add('poll-survey-toggle__toggle-icon--visible');
        }, 300);
    };
    PollSurvey.prototype.action = function () {
        var _this = this;
        // fields
        var inputs = Array.from(this.form.querySelectorAll('input, select, textarea'));
        var loader = this.containerLoader;
        var thankyou = this.containerSuccess;
        var pollId = this.attributePollId;
        // inputs
        this.containerForm.classList.add('d-none');
        this.containerLoader.classList.remove('d-none');
        // postdata
        var values = {};
        var postData = '';
        var fields = [];
        // inputs
        inputs.map(function (field) {
            var getName = field.getAttribute('name');
            var getType = field.getAttribute('type');
            var getValue = field.value;
            getName = getName.replace(' ', '_');
            if (fields[getName]) {
                var currentValue = fields[getName].value;
                if (getType === 'checkbox') {
                    if (field.checked) {
                        currentValue += ',' + field.value;
                    }
                }
                else if (getType === 'radio') {
                }
                else {
                    currentValue += ',' + field.value;
                }
                fields[getName].value = currentValue;
            }
            else {
                if (getType === 'radio') {
                    var radioButtons = Array.from(_this.form.querySelectorAll("input[name='" + getName + "']"));
                    radioButtons.map(function (button) {
                        if (button.checked) {
                            getValue = button.value;
                        }
                    });
                }
                fields[getName] = {
                    name: getName,
                    value: getValue
                };
            }
        });
        var objectKeys = Object.keys(fields);
        objectKeys.forEach(function (key) {
            if (key === 'recipient' || key === 'email' || key === 'subject' || key === 'redirect') {
            }
            else {
                values[key] = fields[key].value;
            }
        });
        if (this.attributeQuestion) {
            var answers = {};
            answers.question = this.attributeQuestion;
            answers.answers = values;
            postData += 'questions=' + JSON.stringify(answers);
        }
        else {
            postData += 'questions=' + JSON.stringify(values);
        }
        // attributes
        if (this.attributeSitename) {
            postData += '&sitename=' + this.attributeSitename;
        }
        if (this.attributeFormName) {
            postData += '&formname=' + this.attributeFormName;
        }
        if (this.attributeDisplayName) {
            postData += '&displayname=' + this.attributeDisplayName;
        }
        if (this.attributePageUrl) {
            postData += '&pageurl=' + this.attributePageUrl;
        }
        if (this.attributePollId) {
            postData += '&formid=' + this.attributePollId;
        }
        if (this.attributeQuestion) {
            postData += '&question=' + this.attributeQuestion;
        }
        if (this.attributeAnalyticsName) {
            postData += '&analyticsformname=' + this.attributeAnalyticsName;
        }
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/PollSurveyRegister.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            localStorage.setItem('sbgPollSubmitted', pollId);
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.add('d-none');
            thankyou.classList.remove('d-none');
        }).catch(function (response) {
            // service failed
            localStorage.setItem('sbgPollSubmitted', pollId);
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.add('d-none');
            thankyou.classList.remove('d-none');
        });
    };
    return PollSurvey;
}(Base));
export { PollSurvey };



//////////////////
// WEBPACK FOOTER
// ./components/poll-survey/poll-survey.component.ts
// module id = 437
// module chunks = 0